import React from "react";   
import CadTagsPanelListPageContainer from "./CadTagsPanelListPageContainer";

export class CadTagsPanelPage extends React.Component {
  render() {
    return <CadTagsPanelListPageContainer {...this.props} />;
  }
}
